import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=2a0d96e6&scoped=true&"
import script from "./Timeline.vue?vue&type=script&lang=ts&"
export * from "./Timeline.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0d96e6",
  null
  
)

export default component.exports